const locale = {
  SKILL_TRACKER_TEXT: 'Skill tracker:',
  BACKLOG_LABEL_TEXT: 'Gaps',
  LEARNING_LABEL_TEXT: 'Upskilling objectives',
  COMPLETED_LABEL_TEXT: 'Acquired',
};

export default locale;
